var map = {
	"./en_us/common.json": 63733,
	"./en_us/dataset.json": 46144,
	"./en_us/interface.json": 15971,
	"./en_us/project.json": 70241,
	"./ko_kr/common.json": 26331,
	"./ko_kr/dataset.json": 54726,
	"./ko_kr/interface.json": 95301,
	"./ko_kr/project.json": 48251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;